import isObject from 'lodash-es/isObject';
import { w } from '@dojo/framework/core/vdom';
import { GenerateItem } from '../topic-widgets/generate-item';
export const isEleWithKids = (v) => {
    return isObject(v) && 'children' in v;
};
export const isSimpleTopic = (v) => {
    return isObject(v);
};
export const render_topic_content = (topicdata) => {
    if (isEleWithKids(topicdata)) {
        return topicdata.children && Array.isArray(topicdata.children)
            ? topicdata.children?.map((item) => {
                return w(GenerateItem, { item });
            })
            : [];
    }
    else if (isSimpleTopic(topicdata)) {
        return [w(GenerateItem, { item: topicdata })];
    }
    else if (typeof topicdata === 'string') {
        return [topicdata];
    }
    return [];
};
export const extract_accordion_children = (element) => {
    const key = Object.keys(element)[0];
    const { children = [], attributes = { id: '' } } = element[key];
    const clean_embedded_tabs = (container) => {
        const key = Object.keys(container)[0];
        const { children = [], attributes = {} } = container[key];
        const tab = children.filter((kid) => {
            return 'ph' in kid;
        });
        const embedded_tab = tab.map((kid) => {
            const tabKey = Object.keys(kid)[0];
            const { children } = kid[tabKey];
            return { ph: { attributes: {}, children } };
        });
        const pane_content = children.filter((kid) => {
            return 'ph' in kid === false;
        });
        return [...tab, { ph: { attributes, children: [...embedded_tab, ...pane_content] } }];
    };
    if (key === 'p') {
        const accordion = children.length && children.length < 2 ? clean_embedded_tabs(children[0]) : [...children];
        const title = w(GenerateItem, { item: accordion[0] });
        const content = w(GenerateItem, { item: accordion[1] });
        return attributes.id ? { key: attributes.id, title, content } : { title, content };
    }
    else {
        return children.flatMap((kids) => {
            return extract_accordion_children(kids);
        });
    }
};
